import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  ADMIN_GET_CUSTOMER,
  GET_VERIFIED_MERCHANT,
  GET_CUSTOMER_COUNT,
  ELASTIC_SEARCH_BASE_URL,
} from "../../../Constants/Config";
import axios from "axios";
const initialState = {
  loading: false,
  CustomerRecord: {},
  CustomerRecordCount: 0,
  successMessage: "",
  error: "",
};

export const CustomerUpdate = createAsyncThunk(
  "Customer/CustomerUpdate",
  async (data) => {
    // console.log("update data")
    // return data
    // const response = await axios.post( BASE_URL+ADMIN_GET_CUSTOMER,data, { headers: { "Content-Type": "multipart/form-data" } })
    // // console.log(response.data.status)
    // if (response.data.status === 200) {
    //     // console.log()
    //     return response.data.message
    // }
  }
);

export const CustomerFunction = createAsyncThunk(
  "Customer/CustomerFunction",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...newData } = data;
      newData["user_type"] = "customer";
      // const currentUrl = window?.location?.pathname || "";
      // const isOldUrl = currentUrl.endsWith("/old");
      // let baseurl = isOldUrl
      //   ? BASE_URL
      //   : ELASTIC_SEARCH_BASE_URL && ELASTIC_SEARCH_BASE_URL.length
      //   ? ELASTIC_SEARCH_BASE_URL
      //   : BASE_URL;
      const response = await axios.post(
        BASE_URL + ADMIN_GET_CUSTOMER,
        newData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
        }
      );
      if (response.data.status === 200) {
        return response.data.message;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getCustomersCount = createAsyncThunk(
  "Customer/getCustomersCount",
  async (data) => {
    // console.log(data)
    const { token, ...dataNew } = data;
    const response = await axios.post(BASE_URL + GET_CUSTOMER_COUNT, dataNew, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`, // Use data?.token directly
      },
    });
    // console.log("customer count: ", response);
    if (response.data.status == 200) {
      return response.data.data_count;
    }
  }
);

const CustomerSlice = createSlice({
  name: "Customer",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(CustomerFunction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(CustomerFunction.fulfilled, (state, action) => {
      state.loading = false;
      state.CustomerRecord = action.payload;
      state.error = "";
    });
    builder.addCase(CustomerFunction.rejected, (state, action) => {
      state.loading = false;
      state.CustomerRecord = {};
      state.error = action.error.message;
    });
    builder.addCase(CustomerUpdate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(CustomerUpdate.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(CustomerUpdate.rejected, (state, action) => {
      state.loading = false;
      state.successMessage = action.payload;
    });
    builder.addCase(getCustomersCount.fulfilled, (state, action) => {
      state.CustomerRecordCount = action.payload;
    });
    builder.addCase(getCustomersCount.rejected, (state, action) => {
      state.CustomerRecordCount = 0;
    });
  },
});

export const { updatecustomerData } = CustomerSlice.actions;

export default CustomerSlice.reducer;
